import { render, staticRenderFns } from "./ClientEditableDetail.vue?vue&type=template&id=768500e3&scoped=true"
import script from "./ClientEditableDetail.vue?vue&type=script&lang=ts"
export * from "./ClientEditableDetail.vue?vue&type=script&lang=ts"
import style0 from "./ClientEditableDetail.vue?vue&type=style&index=0&id=768500e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768500e3",
  null
  
)

export default component.exports